import { TFunction } from "i18next";
import { ProductCardData } from "../types/onboarding";

export const getProductCards = (t: TFunction): ProductCardData[] => [
    {
        frontTitle: t('ProductCards.physical.title'),
        frontDescription: t('ProductCards.physical.description'),
        iconType: 'physical',
        frontBackgroundImage: "https://upload-file-droplinked.s3.amazonaws.com/c9aa9b3ba3a5a8b6ef9a650a5543b5130ef4b9c29865e1bba8f2598e0ff94d0a.png",
        backBackgroundImage: "https://upload-file-droplinked.s3.amazonaws.com/53413eabaf9a21468d77a317bde0940a299905f839a64675e48256eaf80f5ae6.png",
    },
    {
        frontTitle: t('ProductCards.digital.title'),
        frontDescription: t('ProductCards.digital.description'),
        iconType: 'digital',
        frontBackgroundImage: "https://upload-file-droplinked.s3.amazonaws.com/2461afe1fb171e4060871f2a1def279cf014cd1af4a5530ae4be492169ec8df3.png",
        backBackgroundImage: "https://upload-file-droplinked.s3.amazonaws.com/ce97332591171c5538502b98eaabeb058a6646eb51591dafb8197ecfba65e157.png",
    },
    {
        isMockElement: true
    },
    {
        frontTitle: t('ProductCards.print.title'),
        frontDescription: t('ProductCards.print.description'),
        iconType: 'print',
        frontBackgroundImage: "https://upload-file-droplinked.s3.amazonaws.com/2c50395e45b60e7ce873f3ce716bf4edaf1f67b20fe883050c273696726e426f.png",
        backBackgroundImage: "https://upload-file-droplinked.s3.amazonaws.com/0f2e6f3ddd837ae88f16bc531365cc9c7c3f21e2d1250d54af2bc44aa6952391.png",
    },
    {
        frontTitle: t('ProductCards.nft.title'),
        frontDescription: t('ProductCards.nft.description'),
        iconType: 'nft',
        frontBackgroundImage: "https://upload-file-droplinked.s3.amazonaws.com/0e1e7b98d2f6695872bd8e20902a1677db3ac41d7c35c01a84581e1f3706c011.png",
        backBackgroundImage: "https://upload-file-droplinked.s3.amazonaws.com/35d554f2da8e40831838140a32fc4c636bb431cd21d2a608aec396635d6a0898.png",
    },
    {
        isMockElement: true
    },
    {
        isMockElement: true
    },
    {
        isMockElement: true
    },
    {
        isMockElement: true
    },
]